import React, { useEffect, useState } from "react";
import AuthService, { getConnection, saveConnection } from "../../HTTP/auth.service";
import "./Login.css";
import bienvenue from "../../media/bienvenue.jpg";
import register from "../../media/enregis.jpeg";
import { countries } from '../../global/countriesAndSources'
import Logo from "../../media/logonobg.png";
import { isUserSubscribed } from "../../HTTP/user";

const Login = () => {
  // États
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [errorMsgPopUp, setErrorMsgPopUp] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [newpassword, setNewpassword] = useState("");
  const [RePassword, setRePassword] = useState("");
  const [auth, setauth] = useState('login')
  const [lastname, setLastname] = useState("");
  const [firstname, setFirstname] = useState("");
  const [email, setEmail] = useState("");
  const [popUpConnection, setPopupConnection] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [twoFA, setTwoFA] = useState(false)
  const [infosAfterLogin, setInfosAfterLogin] = useState({})
  const [codeTwoFA, setCodeTwoFA] = useState("")
  const [islogin, setislogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState({
    username: false,
    password: false,
    newpassword: false,
    Repassword: false,
    firstname: false,
    lastname: false,
    email: false,
  })

  // Vérification token sécurisée avec useEffect
  useEffect(() => {
    const token = localStorage.getItem("token");
    const tokenAge = localStorage.getItem("token_age");
    
    if (token && tokenAge) {
      const now = new Date().getTime();
      const tokenTime = parseInt(tokenAge);
      // Vérifier si le token n'est pas trop ancien (24h)
      if (now - tokenTime < 86400000) {
        window.location = "/";
      } else {
        // Token expiré, le nettoyer
        localStorage.removeItem("token");
        localStorage.removeItem("token_age");
        localStorage.removeItem("user");
      }
    }
  }, []);

  // Vérification 2FA seulement si nécessaire
  useEffect(() => {
    const fetchTwoFA = async () => {
      try {
        const response = await AuthService.isTwoFAActivated()
        console.log("2FA Status:", response);
        setTwoFA(response || false)
      } catch (error) {
        console.log("Erreur 2FA:", error);
        setTwoFA(false)
      }
    }
    
    // Ne vérifier le 2FA que si on n'est pas en mode inscription
    if (auth === 'login') {
      fetchTwoFA()
    }
  }, [auth])

  const checkCode = async () => {
    if (codeTwoFA.length === 6) {
      try {
        const response = await AuthService.verify2faCode(infosAfterLogin.user.email, codeTwoFA)
        if (response) {
          setPopupConnection(false)
          logginIn(infosAfterLogin)
        } else {
          setErrorMsgPopUp("Incorrect code")
        } 
      } catch (error) {
        const errMessage = error?.response?.data?.message || error.message || error.toString()
        setErrorMsgPopUp(errMessage)
      }
    } else {
      setErrorMsgPopUp("The code must contain 6 digits")
    }
  }

  const logginIn = async (response) => {
    try {
      await saveConnection(response.user.id)
      localStorage.setItem("token", response.token)
      localStorage.setItem("token_age", new Date().getTime())
      localStorage.setItem("user", JSON.stringify(response.user))
      localStorage.setItem("favorites", JSON.stringify(response.favorites))
      const homeCountry = countries.find((co) => co.code === JSON.parse(localStorage.getItem("user")).country)
      sessionStorage.setItem("search_country", JSON.stringify(homeCountry))
      sessionStorage.setItem("search_query", "")
      sessionStorage.setItem("initLang", 'false')
      const sub = await isUserSubscribed(JSON.parse(localStorage.getItem("user")).id)
      if (sub) {
          if (sub.data !== null && sub.data.user_id === JSON.parse(localStorage.getItem("user")).id) {
              localStorage.setItem("subscriptions", JSON.stringify(sub.data))
          }
      }
      setTimeout(() => window.location = "/", 600)
    } catch (error) {
      console.error("Erreur lors de la connexion:", error);
      setErrorMsg("Connection error")
    }
  }

  const handlelogin = async (e) => {
    e.preventDefault();
    
    if (isLoading) return; // Empêcher les doubles clics
    
    if (username === "" || password === "") {
        setErrorMsg("All fields are required!");
        return;
    }

    setIsLoading(true);
    setErrorMsg("");

    try {
      console.log("Tentative de connexion pour:", username);
      const response = await AuthService.login(username, password)
      console.log("Réponse de connexion:", response)
      
      // const connectedAlone = await getConnection(response.user.id)
      // console.log("Vérification connexion unique:", connectedAlone);
      
      // if (!connectedAlone) {
      //     setErrorMsg("You are already connected on another device!")
      // } else {
        // Vérifier si l'utilisateur a activé le 2FA
        const userHas2FA = response.user.twoFAEnabled || false; // Ajustez selon votre structure de données
        
        if (userHas2FA && twoFA) {
          console.log("2FA requis");
          setInfosAfterLogin(response)
          setPopupConnection(true)
        } else {
          console.log("Connexion directe");
          logginIn(response)
        }
      // }
    } catch (error) {
      console.error("Erreur de connexion:", error);
      const errMessage = error?.response?.data?.message || error.message || error.toString()
      setErrorMsg(errMessage)
    } finally {
      setIsLoading(false);
    }
  }

  const validateErr = (e) => {
    if (newpassword !== RePassword && RePassword.length > 0) {
      setErrorMsg("Passwords do not match");
    } else {
      setErrorMsg("");
    }

    const { name, value } = e.target;

    // Adaptation pour les nouveaux noms d'attributs
    if (name === "registration-firstname") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, firstname: true }));
      } else {
        setError((prev) => ({ ...prev, firstname: false }));
      }
    }
    if (name === "registration-lastname") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, lastname: true }));
      } else {
        setError((prev) => ({ ...prev, lastname: false }));
      }
    }
    if (name === "registration-email") {
      if (value.trim() === "" || !value.includes("@")) {
        setError((prev) => ({ ...prev, email: true }));
      } else {
        setError((prev) => ({ ...prev, email: false }));
      }
    }
    if (name === "login-username") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, username: true }));
      } else {
        setError((prev) => ({ ...prev, username: false }));
      }
    }
    if (name === "login-password") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, password: true }));
      } else {
        setError((prev) => ({ ...prev, password: false }));
      }
    }
    if (name === "registration-password") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, newpassword: true }));
      } else {
        setError((prev) => ({ ...prev, newpassword: false }));
      }
    }
    if (name === "registration-password-confirm") {
      if (value.trim() === "") {
        setError((prev) => ({ ...prev, Repassword: true }));
      } else {
        setError((prev) => ({ ...prev, Repassword: false }));
      }
    }
}

  const handleRegistration = (e) => {
    e.preventDefault();
    
    if (isLoading) return;
    
    if (RePassword !== newpassword){
        setErrorMsg("Passwords do not match");
        return
    }
    
    if (!selectedCountry) {
        setErrorMsg("Please select a country");
        return
    }
    
    setIsLoading(true);
    setErrorMsg("");
    
    AuthService.registration({
        lastname: lastname,
        firstname: firstname,
        email: email,
        country: selectedCountry,
        password: newpassword,
    })
    .then(async (res) => {
        setSuccessMessage(res)
        // Connecter automatiquement après inscription
        setTimeout(async () => {
          try {
            const loginResponse = await AuthService.login(email, newpassword);
            logginIn(loginResponse);
          } catch (loginError) {
            console.error("Erreur de connexion automatique:", loginError);
            // Rediriger vers la page de connexion
            setauth('login');
            setislogin(false);
            setErrorMsg("Registration successful, please log in");
          }
        }, 1000)
    })
    .catch((err) => {
      console.error("Erreur d'inscription:", err);
      setErrorMsg(err || "An unknown error occurred.")
    })
    .finally(() => {
      setIsLoading(false);
    })
  }

  const handleSignUp = (e) => {
    e.preventDefault();
    setauth("register")
    setislogin(true)
    setErrorMsg("");
  }
  
  const handleGetCodeForResetPassword = (e) => {
    e.preventDefault();
    window.location.href = `/resetpassword`
  }

  return (
    <div className="Bodylogin">
      {popUpConnection && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-xl p-6 w-96 max-w-md">
            <div className="flex flex-col items-center">
              <p className="text-lg font-medium mb-6 text-center">Please enter your connection code sent by email</p>
              <div className="mb-4 w-full">
                <input
                  type="text"
                  value={codeTwoFA}
                  onChange={(e) => setCodeTwoFA(e.target.value)}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full"
                  placeholder="Connection code"
                />
              </div>
              {
                errorMsgPopUp && <div className="divErrMessage"> <p style={{marginTop: 25, fontWeight: 'bold'}}>{errorMsgPopUp}</p> </div>
              }
              <div className="flex justify-center space-x-4 w-full">
                <button 
                  onClick={() => setPopupConnection(false)} 
                  className="px-6 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <button 
                  onClick={() => checkCode()} 
                  className="px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                  style={{ background: "#009AAD", borderColor: "#009AAD" }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className={`containerLogin right-panel-active`} id="container">
        <div className="form-container sign-up-container">
          {islogin === true ? (
            <form onSubmit={handleRegistration} autoComplete="off">
              <img src={Logo} style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginBottom: "15px", marginLeft: "0"}} alt="Logo" />
              
              {errorMsg && <div className="divErrMessage"> <p style={{marginTop: 25, fontWeight: 'bold'}}>{errorMsg}</p> </div>} 
              {successMessage && <div className="divSuccessMessage"> <p style= {{color: "rgb(41, 175, 79)", fontSize: 19, marginTop: 25, fontWeight: 'bold'}}>{successMessage}</p> </div>} 
              
              {error.firstname && (<span className="span-danger">First name is required</span>)}
              <input
                name="registration-firstname"
                autoComplete="given-name"
                onBlur={validateErr}
                required
                type="text"
                value={firstname}
                onChange={(e) => setFirstname(e.target.value)}
                placeholder="First name"
              />
              
              {error.lastname && (<span className="span-danger">Last name is required</span>)}
              <input
                name="registration-lastname"
                autoComplete="family-name"
                onBlur={validateErr}
                required
                type="text"
                value={lastname}
                onChange={(e) => setLastname(e.target.value)}
                placeholder="Last name"
              />
              
              {error.email && (<span className="span-danger">Email is required and must be valid</span>)}
              <input
                name="registration-email"
                autoComplete="email"
                onBlur={validateErr}
                required
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Email"
              />
              
              {error.newpassword && (<span className="span-danger">Password is required</span>)}
              <input
                name="registration-password"
                autoComplete="new-password"
                onBlur={validateErr}
                required
                type="password"
                value={newpassword}
                onChange={(e) => setNewpassword(e.target.value)}
                placeholder="Password"
              />
              
              {error.Repassword && (<span className="span-danger">Password confirmation is required</span>)}
              <input
                name="registration-password-confirm"
                autoComplete="new-password"
                onBlur={validateErr}
                required
                type="password"
                value={RePassword}
                onChange={(e) => setRePassword(e.target.value)}
                placeholder="Confirm Password"
              />

              <div className="input-field">
                <select 
                  id="country_select" 
                  name="registration-country"
                  autoComplete="country"
                  value={selectedCountry}
                  onChange={(e) => setSelectedCountry(e.target.value)}
                  required
                >
                  <option value="">Select a country</option>
                  {countries.map((c, i) => <option value={c.code} key={i}>{c.name}</option>)}
                </select>
              </div>

              <div style={{ display: "flex", width: "66%" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input className="forgetpassipnut" style={{ width: "18px", margin: 0 }} type="checkbox"/>
                  <label style={{ marginLeft: "5px" }} className="forgetpassipnut">
                      Remember password
                  </label>
                </div>
              </div>

              <button 
                type="submit" 
                className="loginButton"
                style={{ marginTop: "8px", background: "#009AAD", borderColor: "#009AAD" }} 
                disabled={isLoading}
              >
                {isLoading ? "Signing up..." : "Sign Up"}
              </button>
            </form>
          ) : (
            <form onSubmit={handlelogin} autoComplete="on">
              {errorMsg && (
                <div className="divErrMessage">
                  <p>{errorMsg}</p>
                </div>
              )}
              <img src={Logo} style={{ width: "220px", marginTop: "0", maxWidth: "80%", marginLeft: "0"}} alt="Logo" />
              <div className="social-container"></div>
              
              <input
                name="login-username"
                autoComplete="username email"
                required
                value={username || ""}
                onChange={(e) => {
                  setusername(e.target.value);
                }}
                placeholder="Email"
                disabled={isLoading}
              />
              <input
                name="login-password"
                autoComplete="current-password"
                required
                value={password || ""}
                onChange={(e) => {
                  setpassword(e.target.value);
                }}
                type="password"
                placeholder="Password"
                disabled={isLoading}
              />
              <button 
                type="button"
                className="forgotPassword" 
                onClick={handleGetCodeForResetPassword}
              >
                Forgot password?
              </button>
              <button
                type="submit"
                className="loginButton"
                style={{ background: "#009AAD", borderColor: "#009AAD" }}
                disabled={isLoading}
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </button>
              <button
                type="button"
                className="loginButton"
                style={{ marginTop: "8px", color: "black" }}
                onClick={handleSignUp}
              >
                Sign Up
              </button>
            </form>
          )}
        </div>

        <div className="overlay-container">
          <div className="overlay">
            <div
              style={ auth === "login" ? { backgroundImage: `url(${bienvenue})` } :  { backgroundImage: `url(${register})` } }
              className="overlay-panel overlay-left"
            >
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;